import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sec_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

// ---- Public ----
export const submitInquiry = async (payload) => {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
};

export const getGallery = async () => {
  const { data } = await axios.get(`${API}/gallery`);
  return data;
};

export const getConsignments = async () => {
  const { data } = await axios.get(`${API}/consignments`);
  return data;
};

export const getProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

// ---- Auth ----
export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
};

export const getMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
  return data;
};

// ---- Admin: inquiries ----
export const getInquiries = async () => {
  const { data } = await axios.get(`${API}/inquiries`, { headers: authHeaders() });
  return data;
};

export const setInquiryStatus = async (id, status) => {
  const { data } = await axios.patch(
    `${API}/inquiries/${id}/status`,
    { status },
    { headers: authHeaders() }
  );
  return data;
};

export const deleteInquiry = async (id) => {
  const { data } = await axios.delete(`${API}/inquiries/${id}`, { headers: authHeaders() });
  return data;
};

// ---- Admin: gallery ----
export const createGalleryItem = async (payload) => {
  const { data } = await axios.post(`${API}/gallery`, payload, { headers: authHeaders() });
  return data;
};

export const updateGalleryItem = async (id, payload) => {
  const { data } = await axios.put(`${API}/gallery/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteGalleryItem = async (id) => {
  const { data } = await axios.delete(`${API}/gallery/${id}`, { headers: authHeaders() });
  return data;
};

// ---- Admin: consignments ----
export const createConsignment = async (payload) => {
  const { data } = await axios.post(`${API}/consignments`, payload, { headers: authHeaders() });
  return data;
};

export const updateConsignment = async (id, payload) => {
  const { data } = await axios.put(`${API}/consignments/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteConsignment = async (id) => {
  const { data } = await axios.delete(`${API}/consignments/${id}`, { headers: authHeaders() });
  return data;
};

// ---- Admin: products (Shop) ----
export const createProduct = async (payload) => {
  const { data } = await axios.post(`${API}/products`, payload, { headers: authHeaders() });
  return data;
};

export const updateProduct = async (id, payload) => {
  const { data } = await axios.put(`${API}/products/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteProduct = async (id) => {
  const { data } = await axios.delete(`${API}/products/${id}`, { headers: authHeaders() });
  return data;
};

// ---- Admin: uploads ----
export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/uploads`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return `${BACKEND_URL}${data.url}`; // absolute URL for <img src>
};

// ---- Slots (public) ----
export const getSlotsConfig = async () => (await axios.get(`${API}/slots/config`)).data;
export const getOpenSlots = async () => (await axios.get(`${API}/slots`)).data;
export const bookSlot = async (id, payload) =>
  (await axios.post(`${API}/slots/${id}/book`, payload)).data;
export const requestSlot = async (id, payload) =>
  (await axios.post(`${API}/slots/${id}/request`, payload)).data;

// ---- Requests (admin) ----
export const adminGetRequests = async () =>
  (await axios.get(`${API}/admin/requests`, { headers: authHeaders() })).data;
export const adminSetRequestStatus = async (id, status) =>
  (await axios.patch(`${API}/admin/requests/${id}`, { status }, { headers: authHeaders() })).data;
export const adminDeleteRequest = async (id) =>
  (await axios.delete(`${API}/admin/requests/${id}`, { headers: authHeaders() })).data;

// ---- Team (admin) ----
export const adminGetTeam = async () =>
  (await axios.get(`${API}/admin/team`, { headers: authHeaders() })).data;
export const adminCreateTeamMember = async (payload) =>
  (await axios.post(`${API}/admin/team`, payload, { headers: authHeaders() })).data;
export const adminDeleteTeamMember = async (email) =>
  (await axios.delete(`${API}/admin/team/${encodeURIComponent(email)}`, { headers: authHeaders() })).data;

// ---- Slots (admin) ----
export const adminGetSlots = async () =>
  (await axios.get(`${API}/admin/slots`, { headers: authHeaders() })).data;
export const adminCreateSlot = async (payload) =>
  (await axios.post(`${API}/admin/slots`, payload, { headers: authHeaders() })).data;
export const adminBulkCreateSlots = async (payload) =>
  (await axios.post(`${API}/admin/slots/bulk`, payload, { headers: authHeaders() })).data;
export const adminSetSlotStatus = async (id, status) =>
  (await axios.patch(`${API}/admin/slots/${id}`, { status }, { headers: authHeaders() })).data;
export const adminDeleteSlot = async (id) =>
  (await axios.delete(`${API}/admin/slots/${id}`, { headers: authHeaders() })).data;
